import { render, staticRenderFns } from "./data-dialog-bimodule.vue?vue&type=template&id=6281a51a&scoped=true&"
import script from "./data-dialog-bimodule.vue?vue&type=script&lang=js&"
export * from "./data-dialog-bimodule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6281a51a",
  null
  
)

export default component.exports